<div class="dialog-wrapper theme-interface content">
  <div class="top-dialog-content">
    <div class="top-header-content">
      <div class="d-flex justify-content-end" *ngIf="!hideCloseButton">
        <span class="close-button font-weight-bold theme-color-header" mat-dialog-close>
          <span>{{ 'admin.store.close' | translate }}</span>
          <i class="fas fa-times theme-color-header"></i>
        </span>
      </div>

      <h1 class="theme-color-header font-size-popup-title">
        {{ dialogTitle }}
      </h1>
      <ng-content></ng-content>
    </div>
  </div>
</div>